import { useState } from "react";
import { Link } from "react-router-dom";
import logoDinte from "../assets/images/logo.png";


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  const menuLinkClass =
    "relative text-gray-700 font-medium tracking-wide transition-all duration-300 ease-out \
     hover:text-blue-600 hover:scale-105 \
     after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-[2px] \
     after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full";

  return (
      <header className="sticky top-0 bg-white/80 backdrop-blur-md shadow-sm border-b border-gray-200 z-50">

      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* LOGO */}
<Link
  to="/"
  onClick={closeMenu}
  className="
    flex
    items-center
    gap-3
    text-3xl
    font-extrabold
    tracking-wide
    text-blue-600
    transition-all
    duration-300
    ease-out
    hover:scale-105
    hover:text-blue-700
  "
>
  <img
    src={logoDinte}
    alt="Artisan Stoma logo"
    className="w-12 h-12 md:w-14 md:h-14 object-contain"

  />
  Artisan Stoma
</Link>


          {/* NAV DESKTOP */}
<nav className="hidden md:flex items-center space-x-8">
  <Link to="/" className={menuLinkClass}>Acasă</Link>
  <Link to="/doctors" className={menuLinkClass}>Doctori</Link>
  <Link to="/services" className={menuLinkClass}>Servicii</Link>
  <Link to="/gallery" className={menuLinkClass}>Galerie foto</Link>
  <Link to="/contact" className={menuLinkClass}>Contact</Link>
</nav>


          {/* CTA DESKTOP */}
          <div className="hidden md:block">
            <Link
              to="/appointment"
              className="
                inline-flex
                items-center
                justify-center
                px-6
                py-3
                font-semibold
                text-blue-600
                border-2
                border-blue-600
                rounded-full
                transition-all
                duration-300
                ease-out
                hover:bg-blue-600
                hover:text-white
                hover:scale-105
                hover:shadow-lg
              "
            >
              Programare Online
            </Link>
          </div>

          {/* BUTON MENIU MOBIL */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black/20 md:hidden"
          onClick={closeMenu}
          onWheel={closeMenu}
          onTouchMove={closeMenu}
        />
      )}

      {/* MENIU MOBIL */}
      <nav
        className={`
          fixed
          top-[72px]
          left-0
          right-0
          md:hidden
          transition-all
          duration-300
          ease-in-out
          ${menuOpen
            ? "translate-y-0 opacity-100"
            : "-translate-y-4 opacity-0 pointer-events-none"}
        `}
      >
        <div
          className="bg-white mx-4 rounded-xl shadow-lg p-6 space-y-6"
          onClick={(e) => e.stopPropagation()}
        >
          {[
  { to: "/", label: "Acasă" },
  { to: "/doctors", label: "Doctori" },
  { to: "/services", label: "Servicii" },
  { to: "/gallery", label: "Galerie foto" },
  { to: "/contact", label: "Contact" },
]
.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={closeMenu}
              className="
                block
                text-center
                text-lg
                font-medium
                text-gray-800
                transition-all
                duration-300
                ease-out
                active:text-blue-600
                active:scale-105
              "
            >
              {item.label}
            </Link>
          ))}

          {/* CTA MOBIL */}
          <Link
            to="/appointment"
            onClick={closeMenu}
            className="
              block
              text-center
              mt-6
              px-6
              py-4
              font-semibold
              text-blue-600
              border-2
              border-blue-600
              rounded-full
              transition-all
              duration-300
              ease-out
              active:bg-blue-600
              active:text-white
              active:scale-95
            "
          >
            Programare Online
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
